import React from 'react';
import './DetailHeader.css';

/**
 * DetailHeader — unified page header for detail pages.
 *
 * Slots:
 *   navigation  — back button or breadcrumb (rendered above the main row)
 *   title       — string, rendered as <h1>
 *   status      — Badge, StatusSelect, or any inline element (placed beside title)
 *   subtitle    — optional small text rendered below the title row
 *   actions     — right-side action area (optional)
 */
function DetailHeader({ navigation, title, status, subtitle, actions }) {
  return (
    <div className="ds-detail-header">
      {navigation && (
        <div className="ds-detail-header__nav">{navigation}</div>
      )}
      <div className="ds-detail-header__main">
        <div className="ds-detail-header__title-block">
          <div className="ds-detail-header__title-row">
            <h1 className="ds-detail-header__title">{title}</h1>
            {status && (
              <div className="ds-detail-header__status">{status}</div>
            )}
          </div>
          {subtitle && (
            <div className="ds-detail-header__subtitle">{subtitle}</div>
          )}
        </div>
        {actions && (
          <div className="ds-detail-header__actions">{actions}</div>
        )}
      </div>
    </div>
  );
}

export default DetailHeader;
